import React, { useState, useEffect } from "react"
import { useCopyToClipboard } from 'usehooks-ts'
import { X } from "lucide-react"
import { useAppCtx, appStore } from "lib/state"
import { queryTools, cn } from "lib/utils"
import { useClipboard } from "lib/hooks/useClipboard"

const phGroups = [
  { label: "#", startsWith: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"] },
  { label: "A", startsWith: ["A"] },
  { label: "B", startsWith: ["B"] },
  { label: "C-D", startsWith: ["C","D"] },
  { label: "E-F", startsWith: ["E","F"] },
  { label: "G-I", startsWith: ["G","H", "I"] },
  { label: "J-L", startsWith: ["J", "K", "L"] },
  { label: "M-N", startsWith: ["M","N"] },
  { label: "O-Q", startsWith: ["O","P","Q"] },
  { label: "R-T", startsWith: ["R","S","T"] },
  { label: "U-W", startsWith: ["U","V","W"] },
  { label: "X-Z", startsWith: ["X","Y","Z"] }
]

export default function PlaceholderChooser({ className="" }:{ className?:string }){

  const { data:_Apidata } = queryTools.resource.parseQueryForApi("apidata.findAll", {}, { enabled: true })

  const [ placeholdersToShow, setPlaceholdersToShow ] = useState<any[]>([])
  const [ selectedItem, setSelectedItem ] = useState<any>(null)
  const [ searchData, setSearchData ] = useState<string>("")
  const { copy, copied, error } = useClipboard()

  const handleCopy = (text:string) => () => {
    copy(text).then(() => console.log(`Copied: ${text}`))
  }

  const getMatchingPlaceholders = (groupStartsWith:string = "Choose") => {
    let result = _Apidata?.filter( (data:any) => data.useInContent === "true" && data.label?.length > 0 )
    if (groupStartsWith !== "Choose") {
      result = result.filter( (data:any) => groupStartsWith.includes(data.label?.charAt(0)) )
    }
    return result.sort( (a:any, b:any) => a.label > b.label ? 1 : -1 )
  }

  const searchApiData = (e:any) => {
    setSearchData(e.target.value)
    if( e.target.value.length <= 2 ) return setPlaceholdersToShow([])
    const result = _Apidata?.filter( (data:any) => data.useInContent === "true" && data.label?.length > 0 && ( data.label?.toLowerCase().startsWith(e.target.value.toLowerCase()) || data.placeholder?.toLowerCase().startsWith(e.target.value.toLowerCase()) ) )
    setPlaceholdersToShow(result.sort( (a:any, b:any) => a.label > b.label ? 1 : -1 ))
  }

  useEffect(() => {
    if( _Apidata ){
      setPlaceholdersToShow(getMatchingPlaceholders("Choose"))
    }
  },[_Apidata])

  return (
    <div className={cn("w-full flex flex-col", className)}>
      <div className="w-full h-8 flex gap-3 border-b border-solid border-slate-500 p-[2px]">
        <select className="w-4/12 bg-slate-900 text-xs" onChange={(e:any) => setPlaceholdersToShow(getMatchingPlaceholders(e.target.value))}>
          <option>Choose</option>
          { phGroups.map( (grp:any) => (
            <option key={grp.label} value={grp.startsWith}>{grp.label}</option>
          ))}
        </select>

        <input 
          type="text" 
          name="search" 
          id="search" 
          value={searchData}
          onChange={searchApiData}
          className="w-8/12 bg-slate-900 text-xs px-2 focus:outline-0" 
          placeholder="Search" 
        />
      </div>

      { placeholdersToShow.length > 0 && (
        <div className="relative w-full h-full flex flex-col justify-start items-start py-[10px] gap-x-1 gap-y-[3px] overflow-y-auto overflow-x-hidden">
          <div className="w-full h-full flex flex-col justify-between">
            <div className="w-full h-full flex flex-col">
              { selectedItem === null && 
                <>
                  { placeholdersToShow.map( (ph:any) => (
                    <div 
                      key={ph._id} 
                      onClick={() => setSelectedItem(ph)}
                      className={cn(
                        "w-full flex justify-start items-start text-neutral-300 cursor-pointer text-sm hover:bg-slate-900 px-2 py-[6px]"
                      )}
                    >
                      { ph.label }
                    </div>
                  )) }
                </>
              }

              { selectedItem !== null && (
                <div className="w-full h-[320px] flex flex-col">
                  <div className="w-full h-full flex flex-col grow-1 bg-slate-900 border border-solid border-slate-500 p-[2px] pr-[1px]">
                    <div className="w-full h-7 bg-teal-800 px-2 flex items-center justify-between text-sm border-b border-solid border-slate-300 mb-2">
                      <div>{`${selectedItem.label.substring(0, 18)} ${selectedItem.label.length > 18 ? "..." : ""}`}</div>
                      <X className="cursor-pointer size-5" onClick={() => setSelectedItem(null)} />
                    </div>
                    <div className="w-full h-full flex flex-col gap-4 px-3 py-[4px] text-sm text-neutral-300">
                      <span>{ selectedItem.description?.length > 0 ? selectedItem.description : "No data available" }</span>
                    </div>
                  </div> 

                  <div className="w-full">
              <button 
                type="button"
                onClick={() => copy(`[[${selectedItem.path}]]`)}
                className="absolute bottom-[12px] left-0 right-0 mx-auto w-[calc(100%-4px)] flex justify-center items-center bg-teal-700 h-6"
              >
                copy to clipboard
              </button>
            </div>
                </div>
              )}
            </div>
          
            
          </div>
        </div>
        )}
    </div>
  )
}